export default {
    data() {
        return {
            selectedTopic: undefined,
            showMenu: false,
            placeholderTextTwo: 'Indicate the subject of the letter',
        }
    },
    props: {
        options: {
            type: [[Array, Object]]
        },
        selected: {
            type: [Object]
        },
        placeholder: [String],
        closeOnOutsideClick: {
            type: [Boolean],
            default: true,
        },
    },
    mounted() {
        if (!this.selected) {
            this.selectedTopic = this.options;
        } else {
            this.selectedTopic = this.selected
        }
        if (this.closeOnOutsideClick) {
            document.addEventListener('click', this.clickHandler);
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', this.clickHandler);
    },
    methods: {
        updateOptionTopic(option) {
            this.selectedTopic = option;
            this.showMenu = false;
            this.$emit('updateOptionTopic', this.selectedTopic);
        },
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        clickHandler(event) {           // click outside the element
            const {target} = event;
            const {$el} = this;
            if (!$el.contains(target)) {
                this.showMenu = false;
            }
        },
    }
}